<template>
  <div :class="$style['broadcast-content']">
    <div :class="$style['sort-wrap']">
      <jtn-ui-radio-group :class="$style['sort']">
        <template slot="items">
          <jtn-ui-radio-btn
            :name="'timeSort'"
            :checked="sortType === 'asc'"
            @change="sortedPosts('asc')"
            >Новые внизу
          </jtn-ui-radio-btn>
          <jtn-ui-radio-btn
            :name="'timeSort'"
            :checked="sortType === 'desc'"
            @change="sortedPosts('desc')"
            >Новые вверху
          </jtn-ui-radio-btn>
        </template>
      </jtn-ui-radio-group>
    </div>

    <jtn-ui-default-btn
      v-if="isActiveBroadcast && newPostsCount == 0"
      :class="$style['broadcast-update-label']"
      :btn-type="'button-online'"
      disabled
      >Трансляция обновляется
    </jtn-ui-default-btn>

    <jtn-ui-default-btn
      v-if="newPostsCount > 0"
      :class="$style['btn']"
      @click="displayNewPosts(true)"
      >{{ newPostLabel }}
    </jtn-ui-default-btn>

    <scrollable-content
      :contentList="recordData.posts"
      :label="showPostLabel"
      :sortType="sortType"
      type="post"
    >
      <no-ssr v-if="!isCommercial && isAdvPlace(index)" slot="adv" slot-scope="{ index }">
        <component
          v-if="getInreadBlock(getAdvIndex(index))"
          v-bind="bindAdvComponent"
          :adv="getInreadBlock(getAdvIndex(index))"
          :index="isRepeatBlock(getAdvIndex(index)) ? index : undefined"
          :clientRender="true"
        />
      </no-ssr>
    </scrollable-content>
  </div>
</template>

<script>
import NoSSR from 'vue-no-ssr';
import { guardUnspecified } from '@portal/utils/util-guards';

import { JtnUiDefaultBtn, JtnUiRadioGroup, JtnUiRadioBtn } from '@jtnews/jtn-ui';
import { scrollToElement } from '@jtnews/shared/scroll-and-position';

import { ScrollableContent } from '../components/scrollable-content';
import { StoreMixin } from '../../../shared/mixins';

import { plural } from '@smh/utils/strings';
import { AdvInread, AdvCreative } from '../../../shared/components/_adv';

export default {
  name: 'BroadcastContent',
  components: {
    JtnUiDefaultBtn,
    JtnUiRadioGroup,
    JtnUiRadioBtn,
    AdvInread,
    AdvCreative,
    ScrollableContent,
    'no-ssr': NoSSR
  },
  mixins: [StoreMixin],
  data() {
    return {
      sortType: '',
      isActiveBroadcast: false,
      newPostsCount: 0,
      newPosts: [],
      updateTime: 60000,
      needScroll: false,
      oldLastIndex: 0,
      $elPageTitle: {},
      pageTitle: '',
      pageTitleInterval: 0,
      lastAdvIndex: 0
    };
  },
  computed: {
    isMobile() {
      return this.store.deviceInfo.isMobile;
    },
    regionId() {
      return this.store.regionId;
    },
    recordBlock() {
      return this.store.layoutModule.record;
    },
    recordData() {
      return this.recordBlock?.data ?? {};
    },
    isCommercial() {
      return this.recordData.isCommercial;
    },
    newPostLabel() {
      return `${this.newPostsCount} ${plural(this.newPostsCount, [
        'новое сообщение',
        'новых сообщения',
        'новых сообщений'
      ])}`;
    },
    showPostLabel() {
      return this.isActiveBroadcast ? 'Показать следующие' : 'Показать предыдущие';
    },
    isScroogeTest() {
      return this.store.layoutModule.isScroogeTest;
    },
    bindAdvComponent() {
      return {
        is: this.isScroogeTest ? 'AdvCreative' : 'AdvInread'
      };
    }
  },
  mounted() {
    if (this.recordData.updatesStatus && this.recordData.updatesStatus === 'stoped') {
      this.sortType = 'asc';
    } else {
      this.isActiveBroadcast = true;
      this.sortType = 'desc';
      this.updateInterval = setInterval(() => {
        this.getNewPosts();
      }, this.updateTime);
      this.getNewPosts(true);
    }
    // eslint-disable-next-line
    this.$elPageTitle = document.getElementsByTagName('title')[0];
    this.pageTitleText = this.$elPageTitle.innerText;
  },
  updated() {
    if (this.needScroll) {
      this.scrollToNewPost();
    }
  },
  beforeDestroy() {
    clearInterval(this.updateInterval);
    clearInterval(this.pageTitleInterval);
  },
  methods: {
    async getNewPosts(isShowImmediately = false) {
      let timestamp = this.recordData.posts.length > 0 ? this.recordData.posts[0].id : 0;

      if (this.sortType === 'asc') {
        timestamp = this.recordData.posts[this.recordData.posts.length - 1].id;
      }

      try {
        const result = await this.store.newsApiClient.getRecordNewPosts(
          this.regionId,
          this.store.route.params.id,
          timestamp
        );
        const data = result?.translation_posts.data ?? {};

        if (data.posts?.length) {
          this.newPostsCount = data.total;
          this.newPosts = data.posts;
          this.checkStatusBroadcast(data.updatesStatus);
          this.updatePageTitle();
          if (isShowImmediately) {
            this.displayNewPosts();
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    sortedPosts(sortType) {
      if (this.newPosts.length > 0) {
        this.displayNewPosts(false);
      }
      this.sortType = sortType;
      this.recordData.posts.reverse();
      this.store.layoutModule.imageViewerService.changePostImageSortType(sortType);
      const title = sortType === 'asc' ? 'Новые внизу' : 'Новые вверху';
      this.$emit('sortedPosts', title);
    },
    displayNewPosts(scrollToPost) {
      this.oldLastIndex = this.recordData.posts.length - 1;
      // eslint-disable-next-line
      this.newPosts.map(newPost => {
        if (this.sortType === 'asc') {
          this.recordData.posts.push(newPost);
        } else {
          this.recordData.posts.unshift(newPost);
        }
      });

      if (scrollToPost && this.sortType === 'asc') {
        this.needScroll = true;
      }

      this.newPostsCount = 0;
      this.newPosts = [];

      this.updatePageTitle();
    },
    checkStatusBroadcast(newStatus) {
      if (newStatus === 'stoped') {
        this.isActiveBroadcast = false;
        clearInterval(this.updateInterval);
      }
    },
    scrollToNewPost() {
      const refNewPost = `post${this.oldLastIndex + 1}`;
      scrollToElement(this.$refs[refNewPost][0], 500);
      this.needScroll = false;
    },
    updatePageTitle() {
      clearInterval(this.pageTitleInterval);

      if (this.newPostsCount > 0) {
        let newTitle = true;

        this.pageTitleInterval = setInterval(() => {
          if (newTitle) {
            newTitle = false;
            this.$elPageTitle.innerText = this.newPostLabel;
          } else {
            newTitle = true;
            this.$elPageTitle.innerText = this.pageTitleText;
          }
        }, 2000);
      } else {
        this.$elPageTitle.innerText = this.pageTitleText;
      }
    },
    isAdvPlace(index) {
      //Расстановка инридов через N постов начиная со второго
      return (index - 1) % 5 === 0;
    },
    getAdvIndex(index) {
      //Math.ceil() нужен для получения индекса следующего по очереди инрида при вставке по условию isLastAdvPlace
      return Math.ceil(((index - 1) / 5) + 1);
    },
    getInreadBlock(advIndex) {
      //Когда блоки закончились вставляем самый последний каждый раз
      if (this.isRepeatBlock(advIndex)) {
        return this.getRepeatAdvBlock();
      }

      return this.getAdvBlock(advIndex);
    },
    getAdvBlock(advIndex) {
      const suffix = advIndex === 1 ? '' : advIndex;
      const advBlockName = this.isMobile ? 'mobileRecordInreadAdvert' + suffix : 'desktopRecordInreadAdvert' + suffix;
      return this.store.advModule[advBlockName];
    },
    isRepeatBlock(advIndex) {
      return !guardUnspecified(this.getAdvBlock(advIndex));
    },
    getRepeatAdvBlock() {
      const repeatedAdvBlockName = this.isMobile ? 'mobileRecordInreadAdvert6' : 'desktopRecordInreadAdvert3';
      return this.store.advModule[repeatedAdvBlockName];
    }
  }
};
</script>

<style lang="scss" module>
@import 'styles';

.broadcast-content {
  display: flex;
  flex-direction: column;

  & .sort-wrap {
    margin: 0 0 25px;

    background: $color-surface;
  }

  & .sort {
    width: 332px;

    @include on-res($mobile) {
      width: 100%;
    }
  }

  & .btn {
    margin: 0 $desktop-padding 25px;
  }

  & .broadcast-update-label {
    margin: 0 $desktop-padding 25px;
  }
}
</style>
